import { render } from "./ArrowDown.vue?vue&type=template&id=65984b6f&scoped=true"
const script = {}

import "./ArrowDown.vue?vue&type=style&index=0&id=65984b6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_typescript@7.0.2__webpack@5.111.0_postcss@8.5.28_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65984b6f"]])

export default __exports__